import React from "react";
import Select from "@mui/material/Select";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import InputLabel from "@mui/material/InputLabel";

export default function SelectWithClear({
  children,
  disabled,
  value,
  label,
  name,
  onChange,
}) {
  const clear = () => {
    let e = {
      target: {
        value: null,
      },
    };
    onChange(e);
  };

  return (
    <>
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        sx={{
          "& .MuiInputAdornment-root": { position: "absolute", right: "32px" },
        }}
        name={name}
        disabled={disabled}
        size="small"
        color="primary"
        labelId="id"
        value={value}
        onChange={onChange}
        startAdornment={
          value != null && !disabled ? (
            <InputAdornment position="start">
              <IconButton onClick={() => clear()}>
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null
        }
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
      >
        <MenuItem key="ejValt" value={null}>
          Ej valt
        </MenuItem>
        {children}
      </Select>
    </>
  );
}
